import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

interface PortMarkerProps {
  port: {
    id: string;
    name: string;
    coordinates: { lat: number; lng: number };
  };
  containerCount: number;
  onClick: () => void;
}

// Ancoră inline (SVG), folosește `currentColor` pentru a moșteni
// paleta claude_design prin var(--text-muted).
const anchorSvg = (size = 16) => `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  <circle cx="12" cy="5" r="3"/>
  <line x1="12" y1="22" x2="12" y2="8"/>
  <path d="M5 12H2a10 10 0 0 0 20 0h-3"/>
</svg>
`;

const createPortIcon = (count: number) => {
  return L.divIcon({
    html: `
      <div style="position: relative; width: 28px; height: 28px;">
        <div style="
          width: 28px;
          height: 28px;
          border-radius: 999px;
          background: var(--surface, #ffffff);
          color: var(--text-muted, #6b6b66);
          border: 1.5px solid var(--text-muted, #6b6b66);
          display: grid;
          place-items: center;
          box-shadow: 0 2px 5px rgba(0,0,0,0.12);
        ">
          ${anchorSvg(14)}
        </div>
        ${count > 0
          ? `<div style="
              position: absolute;
              top: -4px;
              right: -4px;
              min-width: 18px;
              height: 18px;
              padding: 0 5px;
              border-radius: 999px;
              background: var(--accent, #f5b800);
              color: var(--accent-fg, #1a1a18);
              font-size: 10px;
              font-weight: 700;
              line-height: 1;
              display: grid;
              place-items: center;
              border: 1.5px solid var(--surface, #fff);
              box-shadow: 0 1px 3px rgba(0,0,0,0.18);
              font-family: var(--font-sans, system-ui);
            ">${count}</div>`
          : ''}
      </div>
    `,
    className: 'custom-port-marker',
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
};

export const PortMarker: React.FC<PortMarkerProps> = ({ port, containerCount, onClick }) => {
  const icon = createPortIcon(containerCount);

  return (
    <Marker
      position={[port.coordinates.lat, port.coordinates.lng]}
      icon={icon}
      eventHandlers={{ click: onClick }}
    >
      <Tooltip direction="top" offset={[0, -12]} opacity={1}>
        <div
          style={{
            fontFamily: 'var(--font-sans, system-ui)',
            color: 'var(--text, #2b2a25)',
            minWidth: 140,
          }}
        >
          <div style={{ fontWeight: 600, fontSize: 13 }}>{port.name}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted, #6b6b66)', marginTop: 2 }}>
            {containerCount > 0
              ? `${containerCount} ${containerCount === 1 ? 'container' : 'containere'} în tranzit`
              : 'Fără containere'}
          </div>
        </div>
      </Tooltip>
    </Marker>
  );
};
